import gql from 'graphql-tag';

export const imageBlock = gql`
    fragment imageBlock on contentBlocks_image_BlockType {
        id
        kind
        image @transform(width: 1920, height: 1080, mode: "fit") {
            __typename
            ... on assets_Asset {
                id
                url
                width
                height
                srcset(sizes: ["2048w", "1680w", "1366w", "424w"])
                description
            }
        }
    }
`;

export const imagePair = gql`
    fragment imagePair on contentBlocks_imagePair_BlockType {
        id
        kind
        leftImage {
            ... on assets_Asset {
                __typename
                id
                url
                width
                height
                srcset(sizes: ["1366w", "424w"])
                description
            }
        }
        rightImage {
            ... on assets_Asset {
                __typename
                id
                url
                width
                height
                srcset(sizes: ["1366w", "424w"])
                description
            }
        }
    }
`;

export const textBlock = gql`
    fragment textBlock on contentBlocks_textBlock_BlockType {
        id
        text
    }
`;

export const interviewBlock = gql`
    fragment interviewBlock on contentBlocks_interview_BlockType {
        id
        interviewer {
            fullName
            initials
        }
        interviewee {
            fullName
            initials
        }
        questionsAndAnswers {
            question
            answer
        }
    }
`;

export const sliderBlock = gql`
    fragment sliderBlock on contentBlocks_Slider_BlockType {
        id
        slides @transform(width: 1920, height: 1080, mode: "fit") {
            __typename
            ... on assets_Asset {
                __typename
                title
                id
                url
                width
                height
                srcset(sizes: ["2048w", "1680w", "1366w", "424w"])
                description
            }
        }
    }
`;

export const instagramBlock = gql`
    fragment instagramBlock on contentBlocks_instagram_BlockType {
        id
        __typename
        embedCodes {
            embedCode
        }
    }
`;

export const videoBlock = gql`
    fragment videoBlock on contentBlocks_video_BlockType {
        id
        __typename
        video {
            ... on assets_Asset {
                __typename
                title
                kind
                url
                width
                height
                mimeType
                description
            }
            embeddedAsset {
                ... on EmbeddedAsset {
                    __typename
                    title
                    description
                    aspectRatio
                    height
                    width
                    html
                }
            }
        }
    }
`;
